import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { useActivityLogger } from '@/hooks/useActivityLogger';
import { AuthLayout } from '@/components/AuthLayout';

const Logout = () => {
  const navigate = useNavigate();
  const { signOut } = useAuth();
  const { logLogout } = useActivityLogger();

  useEffect(() => {
    const handleLogout = async () => {
      // Log logout activity
      await logLogout({ 
        redirect_url: '/auth/login',
        cross_domain: false 
      });
      
      // Sign out - cookie automatically cleared across all *.bluelux.com subdomains
      await signOut();
      
      // Redirect to login
      navigate('/auth/login', { replace: true });
    };
    
    handleLogout();
  }, [signOut, logLogout, navigate]);

  return (
    <AuthLayout>
      <div className="text-center space-y-4">
        <div className="animate-pulse">
          <h2 className="text-2xl font-semibold text-foreground">Signing out...</h2>
          <p className="text-muted-foreground mt-2">Please wait while we log you out</p>
        </div>
      </div>
    </AuthLayout>
  );
};

export default Logout;
